import { FC, useState } from 'react';

import { LogoAvatarIcon } from '@/components/ui/Icons/Icons';
import { ColTypes } from '@/constants/common';

import { computeAvatarNameFontSizes, getAvatarText } from './Avatar.helpers';
import * as S from './Avatar.styles';

interface AvatarProps {
  name?: string | null;
  image?: string | null;
  dataCy?: string;
  sizes: ColTypes;
  showInitials?: boolean;
}

export const Avatar: FC<AvatarProps> = ({
  name,
  image,
  sizes,
  dataCy,
  showInitials = true
}) => {
  const [isError, setIsError] = useState(false);
  const showImage = !!image && !isError;
  const computedName = name ?? 'None';

  return (
    <S.AvatarWrapper data-cy={dataCy} $withImage={showImage} $sizes={sizes}>
      {showImage ? (
        <S.AvatarImage
          draggable={false}
          onError={() => setIsError(true)}
          src={image}
          alt={computedName}
          fill
        />
      ) : !showInitials && image === null ? (
        <LogoAvatarIcon />
      ) : (
        <S.AvatarName
          data-testid="avatar-name"
          htmlTag="h3"
          $sizes={computeAvatarNameFontSizes(sizes)}
        >
          {getAvatarText(computedName)}
        </S.AvatarName>
      )}
    </S.AvatarWrapper>
  );
};
